export default __webpack_public_path__ + "static/media/Pessoa_juridica_on.ebede4dc.svg";